import * as Config from '../../../../../config';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import '../../../left-bar/LeftBarContainer.css';

import LogoSection from './LogoSection';
import FilterPlaylistsInput from '../../../left-bar/FilterPlaylistsInput';
import Playlists from '../../../left-bar/Playlists';
import SettingsSection from '../../../left-bar/SettingsSection';
import InformationSection from '../../../left-bar/InformationSection';
import GenresSection from '../../../left-bar/GenresSection';

import MyPlaylistsMenuSection from './MyPlaylistsMenuSection';

import useManageGroup from '../../../left-bar/hooks/useManageGroup';

function ConnectedCustomLeftBarContainer({ height, fullHeight, open, style, showInfoSection }) {

  // Filter Playlists Management
  const [valueFilterPlaylist, setValueFilterPlaylist] = useState('');
  const onChangeValueFilterPlaylist = (e) => setValueFilterPlaylist(e.target.value);
  const clear = () => setValueFilterPlaylist(``);
  const playlistsContainerHeight = height - 165 - (showInfoSection ? 250 : 50); // 200 for the 2 sections

  const { showGroup, accessGroup } = useManageGroup();

  return (
    <div className={`flexColumn left-bar-container`} style={{ ...style, width: Config.SIDE_WIDTH, maxHeight: height - Config.LEFT_PAD_TOP, overflow: 'hidden' }}>
      <LogoSection />

      { (open && fullHeight) ? (
        <>
          {showGroup === 0 && (
            <>
              <MyPlaylistsMenuSection onSelectGenres={accessGroup(2)} />
              <FilterPlaylistsInput placeholder="Search playlists"
                className={`filter-playlists-input`} value={valueFilterPlaylist}
                onChange={onChangeValueFilterPlaylist} showIcon={true} onClear={clear}
              />
              <Playlists filter={valueFilterPlaylist} style={{ height: playlistsContainerHeight, overflowY: `auto` }} />
            </>
          )}
          {showGroup === 2 && <GenresSection onClick={accessGroup(0)} height={height - 127} />}
          { showInfoSection && <InformationSection /> }
          <SettingsSection />
        </>
      ) : null}
    </div>
  )
}

ConnectedCustomLeftBarContainer.propTypes = {
  height: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  style: PropTypes.object
}

const CustomLeftBarContainer = connect(
  state => ({
    open: (state.dimension && state.dimension.isOpen) ? state.dimension.isOpen : false,
    showInfoSection: (!state.isSubscribed)
  })
)(ConnectedCustomLeftBarContainer);

export default CustomLeftBarContainer;
